import React from 'react';
import {
  Card,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import {
  ContextMenu,
  ContextMenuButton,
  ContextMenuItem,
  ProfileCardContent,
  RichTextDisplay,
} from '@marageti/z4-lib';
import { ProfileDetailCardProps } from '../types';
import stylesT from '../styles';

const ProfileDetailCard = ({
  contextMenuAnchor,
  contextMenuOpen,
  onCloseContextMenu,
  onOpenContextMenu,
  onOpenEditor,
  partner,
  partnerDetail,
}: ProfileDetailCardProps) => {
  const theme = useTheme();
  const styles = stylesT(theme);
  const menuId = `profile-detail-context-menu-${partnerDetail.attributeName}`;
  const buttonId = `profile-detail-context-button-${partnerDetail.attributeName}`;
  const attributeName = partnerDetail.attributeName as keyof typeof partner;
  let value = (partner?.[attributeName] || '-');
  if (typeof partner?.[attributeName] === 'boolean') value = partner?.[attributeName] ? 'Yes' : 'No';
  return (
    <Card sx={styles.profileCard}>
      <ProfileCardContent>
        <Stack spacing="24px" width="100%">
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
            <Stack spacing={0.5}>
              <Typography variant="captionBold">
                {partnerDetail.displayName}
              </Typography>
              <RichTextDisplay>
                {value}
              </RichTextDisplay>
            </Stack>
            <ContextMenuButton
              id={buttonId}
              open={contextMenuOpen}
              onClick={onOpenContextMenu}
              menuId={menuId}
            />
            <ContextMenu
              anchorEl={contextMenuAnchor}
              buttonId={buttonId}
              id={menuId}
              onClose={onCloseContextMenu}
              open={contextMenuOpen}
            >
              <ContextMenuItem onClick={onOpenEditor}>
                Edit
              </ContextMenuItem>
            </ContextMenu>
          </Stack>
        </Stack>
      </ProfileCardContent>
    </Card>
  );
};

export default ProfileDetailCard;
